import { render, staticRenderFns } from "./UsAppointment.vue?vue&type=template&id=fd3b27e8"
import script from "./UsAppointment.vue?vue&type=script&lang=js"
export * from "./UsAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports